import { entity } from "./Connection"

export const DataRecordEntity = entity("DataRecord");
